import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/leave-management-system/leave-policy-allocation/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "leave-policy-allocation" entry is kept); the seo block below is a fallback.

export const leavePolicyAllocation: ContentPage = {
  slug: "leave-management-system/leave-policy-allocation",
  template: "hrmsFeature",
  seo: {
    title: "Leave Policy Management - Customize Employee Leave Policies",
    description: "Easily create and manage employee leave policies with our Leave Policy Management system. Customize leave types, entitlements, and carry-forward rules.",
    keywords: [
      "leave policy management",
      "employee leave policies",
      "custom leave types",
      "leave entitlements",
      "carry-forward leave",
      "leave policy customization",
      "HR leave system",
    ],
    ogImage: "/assets/data/seoimages/leave-policy-allocation.webp",
  },
  leaf: {
    hero: {
      caption: "Leave Policy & Allocation",
      title: "Flexible Leave Policy Setup and Management",
      description: "Create, customize, and manage leave policies that fit your business needs. From sick leave to vacation time, our Leave Policy system allows you to set detailed entitlements, accrual rules, and carry-forward options.",
      h1: "caption",
    },
    split: {
      title: "Leave Management for Seamless Workforce Efficiency",
      bullets: [
        { title: "Custom Leave Types", description: "Create specific leave categories like vacation, sick, or family leave." },
        { title: "Leave Entitlements", description: "Set leave entitlements based on role, tenure, and company criteria." },
        { title: "Carry-Forward Rules", description: "Customize rules for carrying forward unused leave to the next year." },
        { title: "Compliance with Local Laws", description: "Ensure leave policies comply with local labor laws to prevent violations." },
      ],
      image: "/assets/images/img/product/hrms/leavems/leave-policy-allocation_info.webp",
      imageAlt: "leave-policy-allocation_info",
    },
    cardsHeading: {
      title: "Key Features of Leave Management System",
      description: "Optimize leave management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Leave Balance",
        href: "/hrms-software/leave-management-system/leave-balance",
        description: "Keep track of employee leave balances in real-time, ensuring transparency and accurate record-keeping.",
        image: "/assets/images/img/product/hrms/leavems/leave_balance_features.webp",
        imageAlt: "leave_balance_features",
      },
      {
        title: "Easy leave Approval",
        href: "/hrms-software/leave-management-system/leave-approval",
        description: "Facilitate quick and easy leave request approvals or declines with a user-friendly workflow, keeping your HR processes efficient.",
        image: "/assets/images/img/product/hrms/leavems/easy_approval_decline.webp",
        imageAlt: "easy_approval_decline",
      },
      {
        title: "Leave Accrual Details",
        href: "/hrms-software/leave-management-system/leave-accrual-details",
        description: "Automate the calculation of leave accruals to ensure accurate and fair leave tracking, eliminating manual errors.",
        image: "/assets/images/img/product/hrms/leavems/leave_accrual_details.webp",
        imageAlt: "leave_accrual_details",
      },
      {
        title: "Leave History",
        href: "/hrms-software/leave-management-system/leave-history",
        description: "Access detailed records of all past leaves, ensuring transparency and easy reference for both employees and HR managers.",
        image: "/assets/images/img/product/hrms/leavems/leave_history.webp",
        imageAlt: "leave_history",
      },
    ],
    testimonials: {
      title: "What Our Customers Say",
      description: "Our clients consistently praise the design and functionality of our templates.",
    },
    bookDemoTitle: "Customize Your Leave Policies Today",
    relatedBlogsKeyword: "what-is-hrms,real-time-leave-tracking",
    metaKey: "leave-policy-allocation",
  },
  sections: [],
};
